import React from "react";

export function ContentLayout({
  title,
  description,
  actions,
  navigation,
  children,
}: {
  title: string;
  description: string;
  actions?: React.ReactNode;
  navigation?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="">
      <div className="flex gap-5 pb-4 mb-4 border-b w-full justify-between items-center">
        <div className="flex gap-1 flex-col space-y-2">
          <span className="border-b-2 border-primary text-2xl font-semibold w-fit font-title">
            {title}
          </span>
          <span className="text-sm text-muted-foreground font-light">
            {description}
          </span>
        </div>
        <div>{actions}</div>
      </div>
      {navigation}
      {children}
    </div>
  );
}
